import React from 'react';
import { Alert } from 'reactstrap';
import i18next from 'i18next';

const ReservationConfigNotFinishedAlert: React.FC<{}> = () => {
  return (
    <Alert color="info">
      <div>{i18next.t('reservation-config-not-finished-alert.not-configured')}</div>
      <div>
        <a href="/settings/reservations">{i18next.t('reservation-config-not-finished-alert.configure-link-text')}</a>
        {i18next.t('reservation-config-not-finished-alert.configure-link-suffix')}{' '}
        <a href="/help">{i18next.t('reservation-config-not-finished-alert.contact-link-text')}</a>
      </div>
    </Alert>
  );
};

export default ReservationConfigNotFinishedAlert;
